import React from "react";
import { Link } from "react-router-dom";

export const PelvicProgramBanner1 = () => {
  return (
    <div>
      <div className="padding-letters-new center-mobile-text no-display-pc">
        <h1 className="margin-text-home  title-pelvic-pragram mt-5">
          A Mind-Body Solution to Pelvic Pain
        </h1>
        {/* <p className="margin-text-home-small-practitioner  text-individual-home text-dark">
            Change the way women experience pelvic care{" "}
            <br className="display-later" /> <br className="display-1285" />
            as a <br className="display-2000" />
            practitioner. Together, we can make it better.
          </p> */}
        <p className="margin-text-home-small-practitioner-pelvic-program-page  text-individual-program text-dark mt-3 p-controller-just-mobile">
          Elana offers a pelvic health restorative program designed <br /> to
          get you healing fast and take back control of your life.
        </p>
        {/* <Link className="text-decoration-none" to="/practitionerSignUp"> */}
        <div className="mt-5">
          <a
            className="margin-text-home-small button-newindividualpage blue-hover text-decoration-none text-white"
            href="#selectYourPlan"
          >
            START A FREE TRIAL
          </a>
        </div>
        {/* </Link> */}
      </div>
      <div className="pelvic-program-banner-1">
        <div className="padding-letters-new center-mobile-text no-display-mobile">
          <h1 className="margin-text-home  title-pelvic-pragram">
            A Mind-Body Solution to Pelvic Pain
          </h1>
          {/* <p className="margin-text-home-small-practitioner  text-individual-home text-dark">
            Change the way women experience pelvic care{" "}
            <br className="display-later" /> <br className="display-1285" />
            as a <br className="display-2000" />
            practitioner. Together, we can make it better.
          </p> */}
          <p className="margin-text-home-small-practitioner  text-individual-program text-dark mt-3">
            Elana offers a pelvic health restorative program designed <br /> to
            get you healing fast and take back control of your life.
          </p>
          {/* <Link className="text-decoration-none" to="/practitionerSignUp"> */}
          <div className="mt-5">
            <a
              className="margin-text-home-small button-newindividualpage blue-hover text-decoration-none"
              href="#selectYourPlan"
            >
              START A FREE TRIAL
            </a>
          </div>
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
};
